// extracted by mini-css-extract-plugin
export default {"Wrapper":"style_Wrapper__KRyqq","Container":"style_Container__ZY6XA","link":"style_link__hKFw7"};